module.exports = function(ngModule) {
  ngModule.config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
    $stateProvider.state('unknown', {
      url: '/unknown',
      template: require('./unknown.html'),
      controller: require('./controller.js'),
      controllerAs: 'vm'
    });
  }]);
};
